// extracted by mini-css-extract-plugin
export default {"inputs":"QPHaybKY","actions":"nkSQt498","prev":"f1OPifxf","next":"jwgRehPz","tooltip":"uHidrMdE"};